export function toThousands(val) {
    let num = (val || 0).toString()
    let result = ''
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result
        num = num.slice(0, num.length - 3)
    }
    if (num) { result = num + result }
    return result
}

export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

export function getCookie(name) {
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].split("=");
      if (cookie[0] === name) {
        return cookie[1];
      }
    }
    return undefined;
  }

export function isAndroid() {
  let ua = navigator.userAgent;
  let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
  return isAndroid
}

export function isiOS() {
  let ua = navigator.userAgent;
  let isiOS = !!ua.match(/Mac OS X.*fresh_iOS/);
  return isiOS
}

export function isMobile() {
    const userAgentInfo = navigator.userAgent;
    const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
     const mobileFlag = mobileAgents.some((mobileAgent) => {
        return userAgentInfo.indexOf(mobileAgent) > -1;
    });

    return mobileFlag;
}

export function centToView(cent) {
  let y = (cent/100).toFixed(2)
  y = parseFloat(y)
  return y.toLocaleString()
}

export function centToMoneyView(val) {
  let money = centToView(val)
  return '₱' + money
}

// eg:2020-01-01
export function formatDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  // const hours = String(date.getHours()).padStart(2, '0');
  // const minutes = String(date.getMinutes()).padStart(2, '0');
  // const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatTimestamp(timestamp, format) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  switch (format) {
      case 'YYYY-MM-DD HH:mm:ss':
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      case 'DD/MM/YYYY HH:mm:ss':
          return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      case 'YYYYMMDDHHmmss':
          return `${year}${month}${day}${hours}${minutes}${seconds}`;
      default:
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js